import React from 'react';

export const Step = ({children}) => {
  return children;
};
